/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  PasswordInput,
  PasswordRequestInput,
  StandardError,
  StandardMessage,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Update password
 */
export const updatePassword = (
    passwordInput: MaybeRefOrGetter<PasswordInput>,
 signal?: AbortSignal
) => {
      passwordInput = toValue(passwordInput);

      return axiosClient<StandardMessage>(
      {url: `/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: passwordInput, signal
    },
      );
    }




export const getUpdatePasswordMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePassword>>, TError,{data: PasswordInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePassword>>, TError,{data: PasswordInput}, TContext> => {

const mutationKey = ['updatePassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePassword>>, {data: PasswordInput}> = (props) => {
          const {data} = props ?? {};

          return  updatePassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof updatePassword>>>
    export type UpdatePasswordMutationBody = PasswordInput
    export type UpdatePasswordMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Update password
 */
export const useUpdatePassword = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePassword>>, TError,{data: PasswordInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePassword>>,
        TError,
        {data: PasswordInput},
        TContext
      > => {
      return useMutation(getUpdatePasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Request Password reset
 */
export const requestPasswordReset = (
    passwordRequestInput: MaybeRefOrGetter<PasswordRequestInput>,
 signal?: AbortSignal
) => {
      passwordRequestInput = toValue(passwordRequestInput);

      return axiosClient<StandardMessage>(
      {url: `/password/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordRequestInput, signal
    },
      );
    }




export const getRequestPasswordResetMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,{data: PasswordRequestInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,{data: PasswordRequestInput}, TContext> => {

const mutationKey = ['requestPasswordReset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPasswordReset>>, {data: PasswordRequestInput}> = (props) => {
          const {data} = props ?? {};

          return  requestPasswordReset(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof requestPasswordReset>>>
    export type RequestPasswordResetMutationBody = PasswordRequestInput
    export type RequestPasswordResetMutationError = ErrorType<ValidationError>

    /**
 * @summary Request Password reset
 */
export const useRequestPasswordReset = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,{data: PasswordRequestInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof requestPasswordReset>>,
        TError,
        {data: PasswordRequestInput},
        TContext
      > => {
      return useMutation(getRequestPasswordResetMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Password with Token
 */
export const updatePasswordWithToken = (
    token: MaybeRefOrGetter<string>,
    passwordInput: MaybeRefOrGetter<PasswordInput>,
 signal?: AbortSignal
) => {
      token = toValue(token);
passwordInput = toValue(passwordInput);

      return axiosClient<StandardMessage>(
      {url: `/password/${token}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: passwordInput, signal
    },
      );
    }




export const getUpdatePasswordWithTokenMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePasswordWithToken>>, TError,{token: string;data: PasswordInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePasswordWithToken>>, TError,{token: string;data: PasswordInput}, TContext> => {

const mutationKey = ['updatePasswordWithToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePasswordWithToken>>, {token: string;data: PasswordInput}> = (props) => {
          const {token,data} = props ?? {};

          return  updatePasswordWithToken(token,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePasswordWithTokenMutationResult = NonNullable<Awaited<ReturnType<typeof updatePasswordWithToken>>>
    export type UpdatePasswordWithTokenMutationBody = PasswordInput
    export type UpdatePasswordWithTokenMutationError = ErrorType<ValidationError>

    /**
 * @summary Update Password with Token
 */
export const useUpdatePasswordWithToken = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePasswordWithToken>>, TError,{token: string;data: PasswordInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePasswordWithToken>>,
        TError,
        {token: string;data: PasswordInput},
        TContext
      > => {
      return useMutation(getUpdatePasswordWithTokenMutationOptions(options), queryClient);
    }
